import { Grid2, Switch, Typography } from "@mui/material";
import ExpandableTypography from "./ExpandableTypography";

const CareStatusDetail = ({ formData, fromReview = false }) => {
  return (
    <>
      {/* Care Status */}
      <Typography variant="h4" color="default.main">
        Care Status
      </Typography>
      {!fromReview && (
        <Typography variant="body1" color="default.light">
          Tell us about the client’s current care situation
        </Typography>
      )}
      <Grid2 container spacing={3} mt={3}>
        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Hospice Status
          </Typography>
          <Typography variant="body1" color="default.light"> {formData?.careStatusSection0?.hospiceStatus ? 'Yes' : 'No'}</Typography>
        </Grid2>
        {formData?.careStatusSection0?.hospiceStatus == true && (
          <>
            <Grid2 size={{ xs: 6, sm: 4 }}>
              <Typography variant="body2" color="default.main" mb={0.5}>
                Hospice Agency
              </Typography>
              <Typography variant="body1" color="default.light">
                {formData?.careStatusSection0?.hospiceAgency || "-"}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 6, sm: 4 }}>
              <Typography variant="body2" color="default.main" mb={0.5}>
                Representative Name
              </Typography>
              <Typography variant="body1" color="default.light">
                {formData?.careStatusSection0?.hospiceRepName || "-"}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 6, sm: 4 }}>
              <Typography variant="body2" color="default.main" mb={0.5}>
                Representative Phone
              </Typography>
              <Typography variant="body1" color="default.light">
                {formData?.careStatusSection0?.hospiceRepPhone || "-"}
              </Typography>
            </Grid2>
          </>
        )}
      </Grid2>
      <Grid2 container spacing={3} mt={3}>
        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Home Health Status
          </Typography>
          <Typography variant="body1" color="default.light"> {formData?.careStatusSection0?.homeHealthStatus ? 'Yes' : 'No'}</Typography>
        </Grid2>
        {formData?.careStatusSection0?.homeHealthStatus == true && (
          <>
            <Grid2 size={{ xs: 6, sm: 4 }}>
              <Typography variant="body2" color="default.main" mb={0.5}>
                Home Agency
              </Typography>
              <Typography variant="body1" color="default.light">
                {formData?.careStatusSection0?.homeAgency || "-"}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 6, sm: 4 }}>
              <Typography variant="body2" color="default.main" mb={0.5}>
                Home Representative Name
              </Typography>
              <Typography variant="body1" color="default.light">
                {formData?.careStatusSection0?.homeRepName || "-"}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 6, sm: 4 }}>
              <Typography variant="body2" color="default.main" mb={0.5}>
                Home Representative Phone
              </Typography>
              <Typography variant="body1" color="default.light">
                {formData?.careStatusSection0?.homeRepPhone || "-"}
              </Typography>
            </Grid2>
          </>
        )}
      </Grid2>
      {/* Primary Care Physician */}
      <Typography variant="h4" color="default.main" mt={4.5}>
        Primary Care Physician
      </Typography>
      {!fromReview && (
        <Typography variant="body1" color="default.light">
          Provide information about the client’s primary doctor
        </Typography>
      )}
      <Grid2 container spacing={3} mt={3}>
        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            First Name
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.primaryCarePhysician?.physicianFirstName || "-"}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Last Name
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.primaryCarePhysician?.physicianLastName || "-"}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Phone Number
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.primaryCarePhysician?.physicianPhoneNumber || "-"}
          </Typography>
        </Grid2>
      </Grid2>

      {/* Additional Information */}
      <Typography variant="h4" color="default.main" mt={4.5}>
        Additional Information
      </Typography>
      <Grid2 container spacing={3} mt={3}>
        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Additional Details
          </Typography>
          <ExpandableTypography chunkSize={300}>
            {formData?.additionalInformation1?.additionalInfo || "-"}
          </ExpandableTypography>
        </Grid2></Grid2>
      <Typography variant="h4" color="default.main" mt={4.5}>
        Signature
      </Typography>
      <Grid2 container spacing={3} mt={3}>
        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Signature
          </Typography>
          <Typography variant="body1" color="default.light">
            <img
              src={formData?.signatureInfo?.signature}
              alt="Signature"
              style={{ maxWidth: "100%", maxHeight: "200px" }}
            />
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Name of Signer
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.signatureInfo?.NameOfSigner || "-"}
          </Typography>
        </Grid2>
      </Grid2>
    </>
  );
};
export default CareStatusDetail;